import { getCountry } from '@iwIntlProvider/CountryProvider';
import { AlertBox, Icon } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { OPEN_BANKING_MODAL } from '../../modals/linkOpenBankingModal/LinkOpenBankingModal.actions';
import { hasRevenueBasedLoan } from '../../revenueBasedLoan/selectors';
import { UNLINK_LINKED_ACCOUNT } from '../TradingData.actions';
import messages from './LinkedAccounts.messages';
import styles from './LinkedAccounts.module.css';
import SingleLinkedProvider from './singleLinkedProvider/SingleLinkedProvider';

const mapStateToProps = (state) => {
    const { tradingData } = state;

    return {
        linkedAccounts: tradingData.linkedAccounts,
        hasRBL: hasRevenueBasedLoan(state)
    };
};

const mapDispatchToProps = {
    linkBankAccount: () => ({ type: OPEN_BANKING_MODAL }),
    unlinkLinkedAccount: (onlineAccountId, onlineAccountName) => ({
        type: UNLINK_LINKED_ACCOUNT,
        onlineAccountId,
        onlineAccountName
    })
};

const LinkedAccounts = ({
    linkBankAccount,
    linkedAccounts = [],
    unlinkLinkedAccount,
    hasRBL
}) => {
    return (
        <>
            <div className={styles.LinkedAccounts}>
                <h3 className={styles.title}>
                    <FormattedMessage {...messages.title} />
                </h3>
                {hasRBL && !linkedAccounts.length && (
                    <AlertBox
                        className={styles.unlinked}
                        variant={getCountry() === 'DE' ? 'connect' : 'failure'}
                    >
                        {getCountry() === 'DE' ? (
                            <Icon icon="infoCircleOutline" />
                        ) : (
                            <Icon icon="exclamationTriangleOutline" />
                        )}
                        <FormattedMessage {...messages.unlinkedError} />
                    </AlertBox>
                )}
                <div className={styles.accountList}>
                    {linkedAccounts.map((linkedAccount) => (
                        <SingleLinkedProvider
                            key={linkedAccount.providerId}
                            {...linkedAccount}
                            unlinkLinkedAccount={unlinkLinkedAccount}
                        />
                    ))}
                </div>
            </div>
            <button
                className={styles.linkNewBankAccount}
                onClick={linkBankAccount}
            >
                <Icon icon="plus" width="24" height="24" />
                <FormattedMessage {...messages.linkAccount} />
            </button>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(LinkedAccounts);
